var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloudLightning = function SvgIconCloudLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.568 3.66A5.375 5.375 0 1 1 14.625 14h-7.5a3.125 3.125 0 1 1 0-6.25h.005q.086 0 .172.004a7 7 0 0 0-.052.871 1 1 0 1 0 2 0 5.375 5.375 0 0 1 3.318-4.966M10.361 16H7.125a5.125 5.125 0 0 1-.003-10.25l.693.045A7.374 7.374 0 1 1 14.625 16h-1.87l-1.15 1.75h2.86a1 1 0 0 1 .836 1.55l-2.465 3.75a1 1 0 0 1-1.672-1.1l1.447-2.2H9.75a1 1 0 0 1-.836-1.55z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCloudLightning;